import { Box, BoxProps } from '@chakra-ui/layout';
import React, { ReactElement } from 'react';

const CenterContent = (props: Omit<BoxProps, 'd' | 'display' | 'justifyContent'>): ReactElement => {
  return <Box d="flex" flexDir="column" justifyContent="center" w="100%" {...props} mb="2rem" />;
};

export default CenterContent;
